import React from 'react';
import cn from 'classnames';
import { Popover } from '../Popover';
import { Tag } from './Tag';
import styles from './TagGroup.module.scss';

export interface ITagGroupProps {
  className?: string;
  maxCharCount?: number;
}

export const TagGroup: React.FC<ITagGroupProps> = ({
  className,
  maxCharCount,
  children,
}) => {
  if (maxCharCount === undefined) {
    return <div className={cn(styles.TagGroup, className)}>{children}</div>;
  }

  let addedChars = 0;
  const hiddenTags: React.ReactNode[] = [];
  const visibleTags = React.Children.map(children, (child) => {
    if (
      React.isValidElement(child) &&
      typeof child.props.children === 'string'
    ) {
      const len = child.props.children.length;
      if (addedChars + len <= maxCharCount) {
        addedChars += len;
        return child;
      }
      hiddenTags.push(child);
      return null;
    }
    return null;
  });

  return (
    <div className={cn(styles.TagGroup, className)}>
      {visibleTags}
      {hiddenTags.length > 0 && (
        <Popover
          content={hiddenTags.map((tag, i) => (
            <div
              key={`tag_${i}`}
              style={{ marginBottom: i < hiddenTags.length - 1 ? 8 : 0 }}
            >
              {tag}
            </div>
          ))}
          className={styles.popover}
        >
          <Tag>+{hiddenTags.length}</Tag>
        </Popover>
      )}
    </div>
  );
};
